import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { scrollTop } from "src/utils/scrollTop";
import { useAppDispatch } from "src/hooks/redux";
import { useModal } from "src/hooks/useModal";
import { logout } from "src/redux/auth/actions";
import { clearCurrentUser } from "src/redux/currentUser/actions";
import { ConfirmationPopupV2 } from "src/components/ConfirmationPopupV2";
import { Button } from "src/components/Button";
import { logoutTrns } from "./trns";

interface Props {
  className?: string;
}
export const LogoutButton: FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const logoutConfirmModal = useModal();

  const onConfirm = () => {
    dispatch(logout());
    dispatch(clearCurrentUser());
    scrollTop();
  };

  return (
    <>
      <ConfirmationPopupV2
        {...logoutConfirmModal}
        description={t(logoutTrns.description)}
        onConfirm={onConfirm}
      />
      <Button className={className} onClick={logoutConfirmModal.openModal}>
        {t(logoutTrns.logoutButton)}
      </Button>
    </>
  );
};
